module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-radio-group"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f1a5747!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/radio/src/radio-group.vue
// module id = 622
// module chunks = 0